// extracted by mini-css-extract-plugin
module.exports = {"display__grid":"WeatherDataPage1_display__grid__3_mMY"};